// extracted by mini-css-extract-plugin
module.exports = {"sidebarContent":"content_sidebarContent__5lY2j","pageContainer":"content_pageContainer__J0TAO"};